import React from 'react';
import PropTypes from 'prop-types';

function getComponentName(Component) {
  if (!Component) {
    return;
  }

  if (Component.displayName) {
    return Component.displayName;
  }

  return Component.name || 'ReactComponent';
}

export type LocationType = {
  pathname: string;
  search: string;
  hash: string;
  state: any;
};

export type HistoryType = {
  length: number;
  action: string;
  location: LocationType;
  push: any;
  replace: any;
  go: any;
  goBack: any;
  goForward: any;
  block: any;
};

export type RouterProps = {
  router: any;
  history: HistoryType;
  // location: any
  match: any;
};

export function withRouter(Component) {
  class WithRouterComponent extends React.Component {
    static WrappedComponent = Component;

    static contextTypes = {
      router: PropTypes.any,
      history: PropTypes.any,
    };

    render() {
      // @ts-ignore
      const { history } = this.context;
      return <Component history={history} {...this.props} />;
    }
  }

  const componentName = getComponentName(Component);
  // @ts-ignore
  WithRouterComponent.displayName = `Connect(${componentName})`;

  return WithRouterComponent;
}
